// extracted by mini-css-extract-plugin
export default {"gradientBorder":"gradientBorder-aadc"};